import { BLOCK_DELAY } from '@emberswap/emberswap-sdk2/dist/constants'
import i18next from 'i18next'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { useDebounce, useIsWindowVisible } from '../../hooks/utils'
import useActiveWeb3React from '../../wagmi/hooks/useActiveWeb3React'
import { updateBlockNumber, updateLanguage } from './actions'
import { useTheme } from './hooks'

/**
 * @return {null}
 */
export default function Updater(): null {
  const { publicClient, chainId } = useActiveWeb3React()
  const dispatch = useDispatch()
  const windowVisible = useIsWindowVisible()
  const theme = useTheme()
  const [state, setState] = useState<{
    chainId: number | undefined
    blockNumber: number | null
  }>({
    chainId,
    blockNumber: null,
  })

  const blockNumberCallback = useCallback(
    (blockNumber: number) => {
      setState((state) => {
        if (chainId && chainId === state.chainId) {
          if (typeof state.blockNumber !== 'number') return { chainId, blockNumber }
          return {
            chainId,
            blockNumber: Math.max(blockNumber, state.blockNumber),
          }
        }
        return state
      })
    },
    [chainId, setState]
  )

  useEffect(() => {
    if (!publicClient || !chainId || !windowVisible) return
    setState({ chainId: chainId, blockNumber: null })
    publicClient
      .getBlockNumber()
      .then((n) => blockNumberCallback(Number(n)))
      .catch((error: any) => {
        return error
      })
    publicClient.watchBlocks({ onBlock: (block) => block.number && blockNumberCallback(Number(block.number))})
   return
  }, [chainId, publicClient, blockNumberCallback, windowVisible])

  const debouncedState = useDebounce(state, BLOCK_DELAY[chainId ? chainId : 0])

  useEffect(() => {
    if (!debouncedState.chainId || !debouncedState.blockNumber || !windowVisible) return
    dispatch(
      updateBlockNumber({
        chainId: debouncedState.chainId,
        blockNumber: debouncedState.blockNumber,
      })
    )
  }, [windowVisible, dispatch, debouncedState.blockNumber, debouncedState.chainId])

  // Theme provider
  useEffect(() => {
    const themeEl = document.querySelector('[name="theme-color"]')
    if (theme === 'dark') {
      document.documentElement.classList.add('dark')
      document?.documentElement?.classList?.remove('dank')
      themeEl && themeEl.setAttribute('content', '#000')
    }
    if (theme === 'light') {
      document?.documentElement?.classList?.remove('dark')
      document?.documentElement?.classList?.remove('dank')
      themeEl && themeEl.setAttribute('content', '#fff')
    }
    if (theme === 'dank') {
      document?.documentElement?.classList?.remove('dark')
      document.documentElement.classList.add('dank')
      themeEl && themeEl.setAttribute('content', '#b1066f')
    }
  }, [theme])

  const locale = i18next.language
  useEffect(() => {
    if (locale) {
      dispatch(updateLanguage({ language: locale }))
    }
  }, [dispatch, locale])
  return null
}
